import { exists } from './exists'

/**
 * 文字列を JSON として解析し、文字列によって記述されている値やオブジェクトを構築します。
 * 解析する文字列が有効な JSON でない場合、 undefined を返します。
 *
 * @template T - 解析後の型。
 * @param text - 解析する文字列。
 * @returns 解析後の値。
 */
export function safeParseJson<T>(
  text: string | null | undefined,
): T | undefined {
  if (!exists(text)) {
    return undefined
  }

  try {
    return JSON.parse(text)
  } catch {
    return undefined
  }
}
